import api from '@/plugins/axios';

export const subscriptionService = {
  async getMySubscription() {
    const response = await api.get('/symbol-service/api/v1/subscription/me');
    return response.data;
  },

  async createCheckoutSession(priceId) {
    const response = await api.post(
      '/symbol-service/api/v1/payments/create-checkout-session',
      { priceId }
    );
    return response.data; // { checkoutUrl }
  },

  async getSubscriptionStatus() {
    const response = await api.get('/symbol-service/api/v1/subscription/status');
    return response.data;
  },

  async cancelSubscription(reason) {
    const response = await api.post('/symbol-service/api/v1/subscription/cancel', { reason });
    return response.data;
  },

  async syncSubscription() {
    const response = await api.post('/symbol-service/api/v1/subscription/sync');
    return response.data;
  },

  async createPortalSession() {
    const response = await api.post('/symbol-service/api/v1/payments/create-portal-session');
    return response.data;
  },

  async reactivateSubscription() {
    const response = await api.post('/symbol-service/api/v1/subscription/reactivate');
    return response.data;
  }
};

export const SubscriptionStatus = {
  ACTIVE: 'ACTIVE',
  CANCELED: 'CANCELED',
  PAST_DUE: 'PAST_DUE',
  TRIALING: 'TRIALING',
  PENDING_CANCELLATION: 'PENDING_CANCELLATION'
};

